<template>
  <reusable-dialog v-model="isVisibleDialog">
    <h3
      slot="title"
      v-text="$t('bill.tips.edit.variants.title')"
    ></h3>

    <!-- TODO: CPME-4399 заменить поле ввода на LabeledInput -->
    <input-text
      ref="tipsVariants"
      v-model="tipsVariants"
      v-m-t="0"
      v-overflow:hidden
      input-id="tips-variants"
      :input-title="$t('enter.variants')"
      :input-name="$t('bill.tips.variant.label')"
      :input-placeholder="$t('bill.tips.variant.label')"
      :formatter="tipsFormatter"
      :required="false"
      @change="tipsVariants = $event"
    >
      <!-- TODO: CPME-4428 Найти решение для использования всплывающих подсказок в модальных окнах -->
      <template v-slot:tooltip="{ focus }">
        <responsive-controller>
          <template #tablet>
            <base-icon
              v-color="focus ? '#2F80ED' : 'white'"
              v-cursor:pointer
              name="notifications_question-circle"
              @click="handleAlert"
            />
          </template>
          <template #default>
            <base-icon
              v-color="focus ? '#2F80ED' : 'white'"
              v-cursor:pointer
              name="notifications_question-circle"
              :title="$t('bill.tips.variant.tooltip')"
            />
          </template>
        </responsive-controller>
      </template>
    </input-text>

    <simple-button
      slot="submit"
      variant="primary"
      @click="handleSubmit"
    >
      {{ $t('common.apply') }}
    </simple-button>

    <simple-button
      slot="cancel"
      variant="transparent"
      @click="isVisibleDialog = false"
    >
      {{ $t('common.cancel') }}
    </simple-button>
  </reusable-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

import InputText from '@/components/inputElements/InputText';
// import BaseTooltip from 'molecules/tooltip/BaseTooltip';
import SimpleButton from 'molecules/common/SimpleButton';

import { tipsFormatter } from '@/pages/invoicing/format';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'TipsVariantsDialog',
  components: {
    InputText,
    // BaseTooltip,
    SimpleButton,
  },
  created() {
    EVENT_BUS.$on('EVENT_SHOW_TIPS_VARIANTS_EDITING', this.initialize);
  },
  beforeDestroy() {
    EVENT_BUS.$off('EVENT_EDIT_TARIFF_VARIANT', this.initialize);
  },
  data() {
    return {
      isVisibleDialog: false,
      tipsVariants: '',
    };
  },
  computed: {
    getPayload() {
      return {
        tips: this.$validate.isEmptyString(this.tipsVariants) ? null : this.tipsVariants,
        publicId: this.SELECTED_TRANSACTION.public_id,
      };
    },
    ...mapState(['SELECTED_TRANSACTION']),
  },
  methods: {
    initialize(data) {
      this.tipsVariants = this.$validate.isArray(data)
        ? data.join(',') : '';

      this.isVisibleDialog = true;
    },
    tipsFormatter(event, oldValue = '') {
      return tipsFormatter(event, oldValue);
    },
    async handleSubmit() {
      const tips = this.tipsVariants
        .split(',')
        .map(tip => Number(tip))
        .filter(i => i);

      try {
        await this.editBill(this.getPayload);
        this.CHANGE_SELECTED_TRANSACTION_TIPS_VARIANTS(tips);

        this.$alert({
          type: 'success',
          text: 'сhanges.saved',
        });
      } catch {
        this.$alert({
          type: 'warning',
          text: 'problems.on.server',
        });
      } finally {
        this.isVisibleDialog = false;
      }
    },
    handleAlert() {
      window.alert(this.$t('bill.tips.variant.tooltip'));
    },
    ...mapActions('bills', ['editBill']),
    ...mapMutations(['CHANGE_SELECTED_TRANSACTION_TIPS_VARIANTS']),
  },
};
</script>
